/*eslint-disable max-len*/

import React from 'react';
import { Container, Flex, Image, Li, Link, MarginBox, Ol, Paragraph, Section, SectionHeader, Text, Ul } from 'UI';

export const TermsAndConditionsTR = () => {
  return (
    <Container size={'md'} alignText={'justify'}>
      <Flex direction={'column'}>
        <MarginBox mt={15} />
        <Flex justify={'center'}>
          <Text type={'h5_bold'}>KULLANIM HÜKÜM VE KOŞULLARI</Text>
        </Flex>
        <MarginBox mt={30} />
        <Section>
          <Paragraph>
            İşbu Genel Kullanım Hüküm ve Koşulları (bundan böyle &quot;GTCU&quot; olarak anılacaktır), kayıtlı ofisi
            122-122 bis avenue du Général Leclerc - 92100 Boulogne-Billancourt adresinde bulunan, Nanterre Ticaret
            Siciline 780 129 987 numarasıyla kayıtlı olan, 533.941.113 € sermayeli Renault, SAS (bundan böyle
            &quot;RENAULT&quot; olarak anılacaktır) tarafından sağlanan RPARTSTORE hizmetine erişimi ve söz konusu
            hizmetin kullanımını düzenler.
          </Paragraph>
          <Paragraph>
            <SectionHeader
              title={
                'KULLANICI BU HÜKÜM VE KOŞULLARI, ONLARI KABUL ETMEDEN VE HİZMETLERE ERİŞMEDEN ÖNCE DİKKATLİCE OKUMALIDIR.'
              }
              underline
            />
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Madde 1'} title={'Platformun Tanımı'} />
          <Paragraph>
            RPARTSTORE web sitesi (bundan böyle &quot;<b>Platform</b>&quot; olarak anılacaktır), işbu genel kullanım
            hükümlerine ve koşullarına (bundan böyle &quot;<b>GTCU</b>&quot; olarak anılacaktır) uygun olarak, bir web
            sitesi aracılığıyla alıcılara (bundan böyle &quot;<b>Alıcılar</b>&quot; olarak anılacaktır) parça ve
            aksesuarlar (bundan böyle &quot;<b>Ürünler</b>&quot; olarak anılacaktır) satışa sunmak isteyen satıcılar
            (bundan böyle &quot;<b>Satıcılar</b>&quot; olarak anılacaktır) arasındaki iletişimi sağlamak için
            kurulmuştur.
          </Paragraph>
          <Paragraph>
            Platform hizmetlerine aşağıdaki e-posta adresinden ulaşılabilir:{' '}
            <Link to={'https://rpartstore.renault.com'} external newTab>
              https://rpartstore.renault.com
            </Link>
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Madde 2'} title={'Barındırma kalitesi'} />
          <Paragraph>
            Platform teknik bir aracı görevi görmektedir. Satıcılara ve Alıcılara (&quot;<b>Kullanıcılar</b>
            &quot;) mevzuat çerçevesinde teknik veri saklama ve taşıma hizmetleri sunmaktadır.
          </Paragraph>
          <Paragraph>
            Platformun rolü tamamen tekniktir ve Satıcılar ile Alıcılar arasındaki iletişimi sağlamakla sınırlıdır.
          </Paragraph>
          <Paragraph>
            Platform, kendisi aracılığıyla gerçekleşebilecek herhangi bir anlaşma, alışveriş, teklif veya çeşitli
            iletişimlerle ilgili olarak hiçbir garanti veya sorumluluk kabul etmez.
          </Paragraph>
          <Paragraph>
            Platform, Satıcılar tarafından Platform aracılığıyla sunulan Ürünlerin hiçbir şekilde satıcısı veya yeniden
            satıcısı değildir.
          </Paragraph>
          <Paragraph>
            Satıcılar tarafından sunulan Ürünlere ilişkin işlemler her zaman Platform dışında, doğrudan Satıcılar ve
            Alıcılar arasında gerçekleştirilir. Satıcı, Platform aracılığıyla sadece ticari bağlantılar oluşturabilir
            (potansiyel müşteri oluşturma platformu). Ürünlerin nihai fiyatı Satıcı tarafından Platform dışında verilir.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Madde 3'} title={'Genel kullanım hüküm ve koşullarının amacı'} />
          <Paragraph>
            İşbu genel kullanım hüküm ve koşullarının amacı, Kullanıcılar tarafından Platforma erişime ve Platformun
            kullanılmasına ilişkin şart ve koşulları tanımlamaktır.
          </Paragraph>
          <Paragraph>
            Platformun amacı, Satıcılar ve Alıcılar arasında ticari bağlantılar oluşturmak amacıyla onlar arasında
            doğrudan dijital bir ilişki oluşturmaktır.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Madde 4'} title={'Alıcılar için Platforma erişim koşulları'} />
          <Paragraph>
            Platforma erişim şu anlama gelir:
            <Ul>
              <Li>
                <Text type={'text'}>
                  Satıcıların, mini üyelik sitesi aracılığıyla Alıcıların katılımlarını talep etmesi
                </Text>
              </Li>
              <Li>
                <Text type={'text'}>Alıcıların Platforma erişiminin Satıcılar tarafından onaylanması</Text>
              </Li>
            </Ul>
          </Paragraph>
          <Paragraph>
            Mini Üyelik Sitesi, Satıcıların Alıcı müşterileri için RPARTSTORE üyeliğine başvurmalarına olanak tanıyan
            bir e-iş uygulamasıdır. Uygulamaya RENAULTNET ve RPARTSTORE&apos;dan erişilebilir.
          </Paragraph>
          <Paragraph>
            Mini üyelik sitesine erişim, erişim için talepte bulunan Satıcıya, Renault ağında kendisine bireysel olarak
            referans verilmesi şartıyla, 0805980450 numarası üzerinden çağrı merkezi tarafından sağlanmaktadır.
          </Paragraph>
          <Paragraph>
            Mini üyelik sitesi üyelik sürecini hızlandırır ve ayrıca Satıcıların, TRESOR ve RPARTSTORE&apos;daki
            kullanıcının niteliğine bakılmaksızın, müşterileri için üyelik talebinde bulunmasına olanak tanır
            (TRESOR&apos;da bilinmeyen müşteri, yeni üyelik, yeni kullanıcı).
          </Paragraph>
          <Paragraph>
            Satıcı, yukarıdaki 4. madde hükümleri uyarınca müşterileri için üyelik talebinde bulunabilir. Müşterinin
            TRESOR veri tabanında tanımlı olmaması durumunda, ilgili TRESOR yöneticisine otomatik olarak bir
            oluşturma/değiştirme talebi gönderilecektir.
          </Paragraph>
          <Paragraph>
            Satıcı, müşterinin bilgilerini değiştirebilir ve üyelik başvurularının ilerleyişini izleyebilir. Açık bir
            uygulamayı değiştiremez ancak kapatılmasını isteyebilir. Çağrı merkezi daha sonra nihai kapanış işlemini
            halleder.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Madde 5'} title={'Platforma kabul edilen ürünler'} />
          <Paragraph>
            Platform, kendisi aracılığıyla sipariş edilebilecek ürün türlerini seçer; Alıcılar, Satıcılardan Platform
            tarafından daha önce seçilenler dışındaki ürünleri Platform aracılığıyla sunmalarını talep edemez veya bunu
            şart koşamaz.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Madde 6'} title={'Sıralama teknolojisi'} />
          <Paragraph>
            Tekliflerin görüntülenmesi önceden belirlenmiş herhangi bir sıralama kriterine tabi değildir. Alıcı
            tarafından yalnızca fiyatın artan veya azalan sıraya göre sıralanması kriterleri seçilebilir ve Alıcı uygun
            olduğu durumlarda bir sıralama sırası belirleyecektir.
          </Paragraph>
          <Paragraph>
            Teklifin gösterimine ilişkin olarak, RENAULT aşağıdaki seçeneklerden birine dayalı şekilde varsayılan bir
            sıralama sırası belirleyebilir:
            <Ul>
              <Li>
                Yaş
                <Ul type={'circle'}>
                  <Li>En eskiden en yeniye</Li>
                  <Li>En yeniden en eskiye</Li>
                </Ul>
              </Li>
              <Li>Fiyat: Artan fiyat</Li>
              <Li>
                İlgi:
                <Ul type={'circle'}>
                  <Li>Rastgele</Li>
                  <Li>Markalar</Li>
                  <Li>Teknik özellikler</Li>
                </Ul>
              </Li>
            </Ul>
          </Paragraph>
          <Paragraph>
            RENAULT, seçilen sınıflandırma opsiyonunu herhangi bir zamanda değiştirme hakkını saklı tutmaktadır. Alıcı,
            aşağıdaki seçeneklerden birini kullanarak bu varsayılan sınıflandırmayı değiştirebilir:
            <Ul>
              <Li>Artan fiyat</Li>
              <Li>Azalan fiyat</Li>
              <Li>Artan yaş: en yeniden en eskiye</Li>
              <Li>Azalan yaş: en eskiden en yeniye</Li>
              <Li>Artan teslim tarihi</Li>
              <Li>Yakınlık (kullanıcılar konuma göre arama yaptığında görünür)</Li>
              <Li>İlgi:</Li>
              <Ul type={'circle'}>
                <Li>
                  <Text type={'text'}>Rastgele</Text>
                </Li>
                <Li>
                  <Text type={'text'}>Markalar</Text>
                </Li>
              </Ul>
            </Ul>
          </Paragraph>
        </Section>

        <Section>
          <SectionHeader
            article={'Madde 7'}
            title={'Alıcı alanının oluşturulması - Tanımlayıcıların ve şifrelerin gizliliği'}
          />
          <Paragraph>
            <Text type={'text'} decoration={'underline'}>
              Aşamalar:
            </Text>
            <Ul type={'decimal'}>
              <Li>
                Satıcıdan talebin dikkate alındığını onaylayan bir e-postanın alınması. E-posta ayrıca talebin 24 ile 72
                saat arasında değişebilecek olan işlem süresini de gösterecektir.
              </Li>
              <Li>
                Alıcı daha sonra RPARTSTORE&apos;a bağlanmak için gerekli bilgileri (ID / Şifre) e-postayla alacaktır.
              </Li>
              <Li>Satıcı ayrıca müşterisinin artık RPARTSTORE&apos;a erişimi olduğunu bildiren bir mesaj alacaktır.</Li>
              <Li>Talep ile ilgili teknik bir olay yaşanması durumunda Satıcı e-posta yoluyla bilgilendirilecektir.</Li>
            </Ul>
          </Paragraph>
          <Paragraph>
            Alıcı Alanının kullanımı kesin surette Satıcı tarafından belirlenen kullanıcıyla sınırlıdır.
          </Paragraph>
          <Paragraph>
            Alıcı, kodlarını gizli tutmayı ve bunları hiçbir şekilde veya hiçbir kişiye ifşa etmemeyi ve hileli veya
            izinsiz kullanım durumunda bunları iptal etmeyi ve durumu gecikmeden 0805980450 numaralı hattan müşteri
            hizmetleri departmanına bildirmeyi taahhüt eder. Alıcı, kodlarının bir üçüncü tarafa açıklanmasının tamamen
            kendi sorumluluğunda olduğu konusunda bilgilendirilir.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Madde 8'} title={'Kişiselleştirilmiş ilişki'} />
          <Paragraph>Alıcılar, Platforma kabul edilen tüm Satıcılardan talepte bulunamaz.</Paragraph>
          <Paragraph>
            Alıcı, Platformda olağan fiziksel kanala karşılık gelen Satıcıyı bulacaktır; Alıcının bağlılığı
            değişmeyecektir.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Madde 9'} title={'Ödeme'} />
          <Paragraph>
            Platform üzerinden yalnızca ticari temasların kurulabileceği ve Platform aracılığıyla herhangi bir ödeme
            yapılmayacağı hususunda mutabık kalınmıştır.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Madde 10'} title={'Platform Hizmetlerinin Kullanılabilirliği'} />
          <Paragraph>
            Geçerli yasa ve düzenlemelerin sınırları dahilinde, RENAULT, Platformun Kullanıcı tarafından kullanımına
            ilişkin tüm sorumluluğu reddeder ve Sitenin hızı ve/veya performansına ya da Alıcı tarafından Platform
            aracılığıyla erişilebilen veri ve/veya bilgilerin kullanımına ilişkin olarak açık veya zımni hiçbir garanti
            vermez.
          </Paragraph>
          <Paragraph>
            RENAULT özellikle de, Platformun herhangi bir hata, kusur veya eksiklik içermeyeceğine veya özellikle
            arızalara, hizmet kesintilerine, bozulmalara veya veri veya bilgi kayıplarına yol açabilecek virüsler olmak
            üzere, hasar veya saldırılara açık olmayacağını garanti etmez.
          </Paragraph>
          <Paragraph>
            Platforma erişim, teknik ekiplerin mümkün olan en kısa sürede çözmeye çalışacağı teknik nedenlerden dolayı
            geçici ve periyodik olarak askıya alınabilir.
          </Paragraph>
          <Paragraph>
            RENAULT aşağıdaki durumlarda tüm sorumluluklardan muaf tutulacaktır:
            <Ol type={'i'}>
              <Li>
                <Text type={'text'}>
                  Kullanıcının işbu Genel Kullanım Hüküm ve Koşullarının gereklerine uymaması halinde;
                </Text>
              </Li>
              <Li>
                <Text type={'text'}>
                  Platformun, Kullanıcıya veya üçüncü kişilere atfedilebilecek iradi veya iradi olmayan sebepler, kötü
                  niyetli bir fiil veya Kullanıcıya ait yazılımların, akıllı telefonların, tablet bilgisayarların veya
                  diğer herhangi bir arayüzün/ürünün arızası sonucu arızalanması durumunda;
                </Text>
              </Li>
              <Li>
                <Text type={'text'}>Platformu etkileyen yasal veya düzenleyici değişiklikler olması durumunda.</Text>
              </Li>
            </Ol>
          </Paragraph>
          <Paragraph>
            Ayrıca Kullanıcı, Platformun iletişim ağları ile sağlanabileceğini ve söz konusu iletişim ağlarının
            arızalanması durumunda RENAULT&apos;un hiçbir şekilde sorumlu tutulamayacağını kabul eder.
          </Paragraph>
          <Paragraph>
            Kullanıcılar Platformu işbu Genel Kullanım Hüküm ve Şartları uyarınca ve geçerli düzenlemelere uygun olarak
            kullanmayı taahhüt ederler.
          </Paragraph>
          <Paragraph>
            Alıcı ve Satıcı, Sitenin kullanımından ve Site aracılığıyla alınan verileri/bilgileri kullananlar kendileri
            değilse bile, söz konusu verilerin/bilgilerin her türlü kullanımından tamamen sorumludur.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Madde 11'} title={'Platformun zarara neden olmaksızın kullanımı'} />
          <Paragraph>
            Alıcı, Platformun faaliyetini tehlikeye atabilecek, itibarına, sağladığı hizmetlerin itibarına ve Renault
            grubunun itibarına ve faaliyetlerine zarar verebilecek her türlü faaliyetten her koşulda kaçınmalıdır.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Madde 12'} title={'Intuitu personae (şahsi ilişki)'} />
          <Paragraph>
            Renault Grubu tarafından kurulan Platform, Renault Grubunun imajına, itibarına ve şöhretine katkıda
            bulunmaktadır. Bu nedenle Platform ile Kullanıcıları arasındaki ilişki &quot;intuitu personae&quot; (şahsi
            ilişki) esasına dayanmaktadır.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Madde 13'} title={'Cayma ve Platformdan engelleme veya çıkarma'} />
          <Text type="base" bold decoration={'underline'}>
            a) Cayma
          </Text>
          <MarginBox mt={5} />
          <Paragraph>
            Herhangi bir Alıcı, Platform hizmetlerini artık kullanmama kararını herhangi bir zamanda R1&apos;i
            aracılığıyla Platforma bildirebilir.
          </Paragraph>
          <Paragraph>
            Alıcı, Platforma katılımının sona erdiği tarihten önce Satıcılar ile akdettiği yükümlülükleri yerine
            getirmeye devam etmelidir.
          </Paragraph>
          <Text type="base" bold decoration={'underline'}>
            b) Engelleme
          </Text>
          <MarginBox mt={5} />
          <Paragraph>
            Platform, Bayi tarafından çevrimiçi olarak yerleştirilen bilgilerin/ögelerin tamamının veya bir kısmının
            erişiminin kısıtlanması, sürümünün düşürülmesi veya askıya alınması (bundan böyle &quot;Kısıtlama
            Tedbirleri&quot; olarak anılacaktır) dahil olmak üzere, gerekli gördüğü her türlü uygun ve orantılı tedbiri,
            aşağıdaki sebeplere dayanarak karar verilen Kısıtlama Tedbirinin önceden bildirimine tabi olarak veya en geç
            uygulamaya koyulduğu gün alabilir:
            <Ol type={'i'}>
              <Li>
                <Text type={'text'}>
                  platforma, işbu Hüküm ve Koşullara, yürürlükteki yasaya veya Renault grubunun imajına ve itibarına
                  zarar veren veya onu ihlal eden kötü niyetli davranışların varlığına ilişkin ciddi varsayım;
                </Text>
              </Li>
              <Li>
                <Text type={'text'}>Alıcı Alanının Alıcı dışındaki kişiler tarafından kullanılması;</Text>
              </Li>
              <Li>
                <Text type={'text'}>gizlilik yükümlülüğünün ihmal edilmesi veya yerine getirilmemesi;</Text>
              </Li>
              <Li>
                <Text type={'text'}>
                  özellikle yetkili bir makam tarafından yasa dışı içeriğe karşı harekete geçmek için düzenlenmiş bir
                  bildirim veya tedbir kararı alınmasının ardından, Platformun yasa dışı olan veya yasa dışı olduğu
                  iddia edilen içeriğin varlığına dair bilgisi.
                </Text>
              </Li>
            </Ol>
          </Paragraph>
          <Paragraph>
            Kısıtlama Tedbiri, altı (6) ayı geçmeyecek şekilde, şikâyet konusu vakıalara orantılı bir süreyle geçerli
            olmak üzere alınır.
          </Paragraph>
          <Paragraph>
            Platform tarafından alınan Kısıtlama Tedbirine dahili şikayet sistemi kullanılarak itiraz edilebilir.
            Alıcının şikayet konusu vakıaları giderememesi durumunda Platform, aşağıda belirtilen koşullar kapsamında
            Alıcıyı kalıcı olarak Platformdan hariç tutabilir.
          </Paragraph>
          <Text type="base" bold decoration={'underline'}>
            c) Platformdan çıkarma
          </Text>
          <MarginBox mt={5} />
          <Paragraph>
            Platform aşağıdaki durumlarda bir Alıcıyı kalıcı olarak Platformdan çıkarabilir:
            <Ol type={'i'}>
              <Li>
                <Text type={'text'}>Herhangi bir nedenle Platforma kabul edilen Renault ağından ayrılmak;</Text>
              </Li>
              <Li>
                <Text type={'text'}>
                  Bu maddenin b - 1) hükmünde belirtilen davranış. Bu nedenle Platform, engelleme ve derhal Platformdan
                  çıkarma seçeneklerinden birine sahip olacaktır;
                </Text>
              </Li>
              <Li>
                <Text type={'text'}>
                  güven ihlali durumu olduğundan, ne kadar ağır olduğunda bakılmaksızın, yalan beyan;
                </Text>
              </Li>
              <Li>
                <Text type={'text'}>
                  Yukarıdaki b°) 2) ila 4)&apos;e kadar olan hükümlerde belirtilen davranışın tekrarı;
                </Text>
              </Li>
              <Li>
                <Text type={'text'}>Satıcıların tekrarlanan şikayetleri;</Text>
              </Li>
              <Li>
                <Text type={'text'}>
                  Alıcının kişisel durumunda, şahsi ilişkiyi etkileyebilecek herhangi bir değişiklik (özellikle:
                  doğrudan veya dolaylı kontrol değişikliği, üretim veya sertifikalarda önemli değişiklik, yürürlükteki
                  yasalar uyarınca iflas (ödeme aczi) işlemleri).
                </Text>
              </Li>
            </Ol>
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Madde 14'} title={'Ticari işlemler - Ticari sır'} />
          <Paragraph>
            Platform, hiçbir şekilde üçüncü kişilerin (rakipler, ortaklar, iş ortakları vb.), Platform aracılığıyla
            gerçekleştirilen veya akdedilen alışverişler, müzakereler, sözleşmeler ve anlaşmalar hakkında bilgi sahibi
            olmasına izin veremez. Platform her zaman gizlilik programına saygı duyacaktır.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Madde 15'} title={'Tanıtım ve reklamlar'} />
          <Paragraph>
            Alıcı, Platformu doğrudan veya dolaylı olarak, kendisinin veya başka herhangi bir kişinin ürünlerini veya
            hizmetlerini doğrudan veya dolaylı olarak ve her ne şekilde olursa olsun tanıtmak amacıyla kullanmamayı
            taahhüt eder.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Madde 16'} title={'Rekabet eden teklifler - Münhasırlık olmaması'} />
          <Paragraph>Platforma üyelik, Alıcılar için Platformu kullanma yükümlülüğü yaratmaz.</Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Madde 17'} title={'Genel Kullanım Koşullarının Değiştirilmesi'} />
          <Paragraph>
            Platform, Genel Kullanım Koşullarını değiştirme hakkını saklı tutar. Herhangi bir değişiklik, Alıcılara
            kendi alanlarında gönderilen bildirimde belirtilen tarihte yürürlüğe girecektir.
          </Paragraph>
          <Paragraph>Değişiklikler, yürürlüğe girdiği tarihte devam eden işlemlere uygulanmayacaktır.</Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Madde 18'} title={'Platform tarafından toplanan kişisel verilerin kullanımı'} />
          <Paragraph>
            Platformun kullanımına ilişkin olarak, kişisel verileriniz RENAULT tarafından aşağıdaki bağlantıdan
            erişilebilen Aydınlatma Metni uyarınca işlenmektedir:{' '}
            <Link to={'https://rpartstore.renault.com/personal-data/tr'} external newTab>
              https://rpartstore.renault.com/personal-data/tr
            </Link>
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Madde 19'} title={'Mücbir sebepler'} />
          <Paragraph>
            Platformun arızalanmasıyla sonuçlanan mücbir sebep hallerinden Platform sorumlu tutulamaz.
          </Paragraph>
          <Paragraph>
            Alıcı ayrıca mücbir sebeplerin sözleşmeye bağlı özelliklerinin, teknik kökenleri bilişim hizmetinin
            tasarımından kaynaklansa dahi, özellikle elektrik kesintilerini, internet ağı arızalarını ve bilgisayar
            arızalarını (&quot;hatalar&quot;, virüsler, kötü amaçlı yazılımlar, izinsiz girişler) içereceğini dikkate
            almayı kabul eder.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Madde 20'} title={'Gizlilik ve delil'} />
          <Paragraph>
            Platform, kendisi aracılığıyla iletilen bilgi ve verilerin veya kendisi aracılığıyla gerçekleştirilen
            müzakerelerin gizliliğini sağlamak ve bunların kendi hizmetleri dışındaki kişilere iletilmemesini sağlamak
            için uygun teknik yöntemleri uygular.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Madde 21'} title={'Fikri mülkiyet'} />
          <Paragraph>
            Platformu oluşturan tüm unsurların (metinler, logolar, resimler, grafik veya ses unsurları, yazılım, düzen,
            veritabanları, kaynak kodu vb.) yanı sıra şirket adları, ticari markalar, tasarımlar ve ayırt edici
            işaretler (bundan sonra &quot;İçerik&quot; olarak anılacaktır) fikri mülkiyet haklarıyla korunmaktadır.
            İçerik, RENAULT&apos;un ve/veya onun kullanımına izin veren üçüncü tarafların münhasır mülkiyetindedir.
          </Paragraph>
          <Paragraph>
            Kullanıcılar, İçeriği sadece işbu belgede açıklanan Platform kullanımı bağlamında kullanmak üzere basit,
            sınırlı, münhasır olmayan, devredilemez, alt lisansı verilmeyen, iptal edilebilir bir lisanstan yararlanır.
            İçeriğin tamamının veya bir kısmının, RENAULT&apos;un önceden yazılı izni olmadan, diğer bilgisayar
            programlarıyla birleştirilme de dahil, herhangi bir proses yoluyla ve herhangi bir ortamda çoğaltılma,
            temsil edilme, uyarlanma, değiştirilme ve kaynak koda dönüştürülme başta olmak üzere, başka herhangi bir
            şekilde kullanılması kesinlikle yasak olup böyle bir kullanım ihlal teşkil etmektedir.
          </Paragraph>
          <Paragraph>
            Kullanıcılar, bu madde hükümlerine aykırı olarak gerçekleştirilen herhangi bir eylemden haberdar olmaları
            halinde RENAULT&apos;u en kısa sürede bilgilendirmeyi taahhüt eder.
          </Paragraph>
          <Paragraph>
            Kullanıcılar, sadece Platformun kullanımı çerçevesi dahilinde olmak üzere, sahibi olduğu veya yasal olarak
            haklarını elde ettiği ticari markaları ve fikri mülkiyet haklarını ve ayrıca ticari unvanını veya yasal
            adını kullanmaya yetkilidir. Kullanıcı, RENAULT&apos;un Kullanıcı tarafından sağlanan unsurları Platformda
            çoğaltmasına izin veren haklara sahip olduğunu taahhüt eder. Bu bağlamda, Kullanıcı, RENAULT&apos;u, söz
            konusu unsurların kullanımıyla bağlantılı olarak herhangi bir üçüncü kişiden kaynaklanan her türlü iddia/hak
            talebi, talep, dava veya kanun yoluna karşı garanti altına almakta olup, bu durum sonucunda, özellikle de,
            kesinleşmeyen bir mahkeme kararı dahil, bir mahkeme kararı veya bir sulh anlaşması sonucunda ortaya
            çıkabilecek tüm masrafları ve zararları karşılayacaktır.
          </Paragraph>
          <Paragraph>
            Kullanıcı, ticari belgelerinde Platformun referans verdiği Kullanıcı statüsünü belirtme yetkisine sahiptir.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Madde 22'} title={'Mücbir sebepler'} />
          <Paragraph>
            İçtihatlarla tanımlanan mücbir sebep niteliğindeki ve Taraflardan herhangi birinin sözleşmeden doğan
            yükümlülükleri üzerinde sonuçları olan herhangi bir olay, söz konusu Tarafın sorumluluğunu doğuramaz.
          </Paragraph>
          <Paragraph>
            Taraflar, özellikle elektrik veya internet ağı arızaları veya bilgisayar arızaları (&quot;hatalar&quot;,
            virüsler, kötü amaçlı yazılımlar, izinsiz girişler gibi) ve Platformun çalışması üzerinde sonuçları olan
            durumlar başta olmak üzere, bu durumları açık bir şekilde mücbir sebep olarak nitelendirmeyi kabul ederler.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Madde 23'} title={'Gizlilik ve delil'} />
          <Paragraph>
            Platform, üçüncü kişilere herhangi bir ifşayı önlemek amacıyla, kendisi üzerinden iletilen tüm bilgi ve
            verilerin yanı sıra kendisi üzerinden yapılan satışların gizliliğini korumak için uygun teknik yöntemleri
            kullanır.
          </Paragraph>
          <Paragraph>
            Bununla birlikte, bu veriler Bayiler ile Müşteriler arasında ve ayrıca Müşteriler ile Platform arasında
            geçerli ve kabul edilebilir deliller olarak değerlendirilecektir.
          </Paragraph>
          <Paragraph>Bu veriler yasal hükümlere uygun olarak saklanacaktır.</Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Madde 24'} title={'Sorumluluk'} />
          <Paragraph>
            Satıcı, RENAULT&apos;un yazılım sunucusu sıfatıyla, Araçların Platformda yayınlanmasının ardından Bayi ile
            Müşteri arasında akdedilen herhangi bir anlaşmanın ve/veya sözleşmenin tarafı olmadığını kabul eder.
          </Paragraph>
          <Paragraph>
            Satıcı, satışa sunduğu Araçların sunumundan veya tanımından, fiyatlarının görüntülenmesinden, yapabileceği
            her türlü iletişim ve reklamdan tek başına sorumludur; buna göre Platform, üzerinde yayımlanan parça ve
            aksesuarların açıklamasında ve/veya belirtilen fiyatlarda Satıcı tarafından yapılan herhangi bir hata veya
            eksiklikten Platform sorumlu tutulamaz.
          </Paragraph>
          <Paragraph>
            Satıcı, Ticaret Kanunu hükümlerinin doğru uygulanmasından ve özellikle de, Platformda çevrimiçi olarak
            sunulan parça ve aksesuarlara ilişkin sözleşmelerin müzakere edilmesi, akdedilmesi ve ifasından ve bilhassa
            ödeme yapılmaması durumunda, Alıcının kendisine karşı yapabileceği/başlatabileceği her türlü şikayet, rücu
            ve ihtilafın yönetilmesinden tek başına sorumludur.
          </Paragraph>
          <Paragraph>
            Daha genel olarak; Satıcı, Satıcı sıfatıyla Alıcılara ve üçüncü kişilere karşı tek başına sorumludur ve bu
            bağlamda olası herhangi bir rücu işlemine karşı RENAULT&apos;u garanti altına almakta olup, özellikle,
            kesinleşmeyen bir mahkeme kararı dahil, bir mahkeme kararı veya bir sulh anlaşması sonucunda olmak üzere
            doğabilecek tüm masraf ve zararları karşılayacaktır.
          </Paragraph>
          <Paragraph>
            Bir Alıcının veya başka herhangi bir kişinin, Satıcının faaliyetleriyle ilgili vakıalar nedeniyle Platforma
            karşı yasal işlem başlatması durumunda, Satıcı, Platformu herhangi bir mahkeme kararına karşı tazmin etmeyi
            taahhüt eder.
          </Paragraph>
          <Paragraph>Satıcı aynı zamanda Satıcı Alanının kullanımından da tek başına sorumludur.</Paragraph>
          <Paragraph>
            Platformda satışa sunulan ürünlere ve aksesuarlara ilişkin verilen bir siparişin sorumluluğu tamamen Alıcıya
            aittir.
          </Paragraph>
          <Paragraph>
            Ayrıca Alıcı Alanlarının kullanımından ve Satıcılara verilen bilgilerden de yalnızca Alıcılar sorumludur.
          </Paragraph>
          <Paragraph>
            Daha genel olarak; Alıcı, Alıcı sıfatıyla tek başına sorumludur ve Platform, Alıcı sıfatıyla sorumlu
            tutulamaz.
          </Paragraph>
          <Paragraph>
            Satıcının veya başka herhangi bir kişinin, Alıcı olarak faaliyetiyle ilgili vakıalar nedeniyle Platforma
            karşı yasal işlem başlatması durumunda, Satıcı, Platformu herhangi bir mahkeme hükmüne karşı tazmin etmeyi
            taahhüt eder.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Madde 25'} title={'Şikâyetler - Bildirim'} />
          <Paragraph type={'text_bold'}>
            <i>a) Dahili şikâyet sistemi</i>
          </Paragraph>
          <Paragraph align={'start'}>
            Platform, aşağıdaki konularda bir dahili şikâyet sistemi kurmuştur:
            <Ul>
              <Li>
                Platformun, şikâyet sahibi Kullanıcıyı etkileyen bir şekilde, çevrimiçi aracılık hizmetlerini
                sağlayamadığı yönündeki bir iddia;
              </Li>
              <Li>
                Aracılık hizmetlerinin sağlanmasıyla doğrudan bağlantılı olan ve şikayette bulunan Kullanıcıyı etkileyen
                teknolojik konular;
              </Li>
              <Li>
                Platform tarafından alınan Kısıtlayıcı Tedbirler veya Platformun şikayette bulunan Kullanıcıyı etkileyen
                ve çevrimiçi aracılık hizmetlerinin sağlanmasıyla doğrudan ilgili olan davranışları.
              </Li>
            </Ul>
          </Paragraph>
          <Paragraph>
            Bildirim sonrasında veya Kullanıcı tarafından sağlanan bilgilerin/unsurların yasa dışı veya Hüküm ve
            Koşullara aykırı olduğu düşünüldüğü gerekçesiyle Platform tarafından alınan Kısıtlayıcı Tedbirlerle ilgili
            olarak, Kullanıcı, söz konusu Tedbirin bildiriminden itibaren 6 ay süreyle şikayette bulunabilir.
          </Paragraph>
          <Paragraph>
            Platform, şikâyetleri, dile getirilen sorunun karmaşıklığı ve önemi ile uyumlu bir zaman dilimi içerisinde
            ele almayı ve şikayette bulunan Kullanıcıya yanıt göndermeyi taahhüt eder.
          </Paragraph>
          <Paragraph>
            Platformun dahili şikâyet sistemi çerçevesinde alınan kararlar, 26. madde kapsamında yargı dışı çözüm
            yollarına veya yargısal çözüm yollarına tabidir.
          </Paragraph>
          <Paragraph type={'text_bold'}>
            <i>b) Bildirim</i>
          </Paragraph>
          <Paragraph>
            <Text type={'text'}>
              Kullanıcı, yasa dışı olduğunu düşündüğü içeriğin Platform&apos;da bulunduğunu belirtmek amacıyla,
              elektronik ortamda her türlü kesin ve gerekçelendirilmiş bildirimde bulunabilir. Bu bildirimler, söz
              konusu yasa dışı niteliğin varlığını kabul edip etmemeye karar verme ve uygun Kısıtlama Tedbirlerini alma
              hakkını saklı tutan Platform tarafından doğrulanacaktır. Platform tarafından alınan karar, şikâyetçinin
              kimliğini belirtmesi halinde kendisine iletilecek ve özellikle de dahili şikayet sistemi aracılığıyla
              olmak üzere, itiraza tabi olacaktır. Platform, teknik veya operasyonel nedenlerden dolayı doğrudan
              harekete geçememesi durumunda, şikâyet sahibini bilgilendirecektir.
            </Text>
          </Paragraph>
          <Paragraph>
            Aşağıdaki adres, tek iletişim noktası olarak görev görecektir:{' '}
            <Link to={'mailto:dpo@renault.com'} external newTab>
              dpo@renault.com
            </Link>
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Madde 26'} title={'Arabuluculuk'} />
          <Paragraph type={'text_bold'}>
            <i>a) Kullanıcılar Arasındaki Uyuşmazlıklar – Arabuluculuk Hizmetinin Sağlanması</i>
          </Paragraph>
          <Paragraph>
            Platform, web sitesinde, Kullanıcıların karşılıklı mutabakat yoluyla anlaşmazlıklarını iletmeye karar
            verebilecekleri bağımsız bir Arabulucu atar. Bu Arabulucuya bir anlaşmazlığın yönlendirilmesi durumu, Hüküm
            ve Koşullardan, parça ve aksesuarların Genel Satış Şartlarından veya Kullanıcılar arasında akdedilen diğer
            sözleşmelerden kaynaklanan yükümlülüklerin askıya alınmasını gerektirir. Arabulucunun, bir karar vermek
            için, kendi takdirine bağlı olarak bir ay veya tarafların mutabakatı halinde daha uzun bir süre
            uzatılabilecek bir şekilde, anlaşmazlığın kendisine iletilmesinden itibaren bir aylık süresi bulunacaktır.
          </Paragraph>
          <Paragraph type={'text_bold'}>
            <i>b) Platform tarafından sunulan hizmetlere ilişkin ihtilaflar</i>
          </Paragraph>
          <Paragraph>
            Yukarıda a) paragrafında belirtilen arabulucuyla, yukarıda belirtilen şartlar altında Platformun herhangi
            bir kullanıcısı tarafından da iletişime geçilebilir. Platform, arabuluculuğa başvurulmasını peşinen kabul
            eder.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Madde 27'} title={'Geçerli Hukuk - İhtilaflar'} />
          <Paragraph>İşbu Genel Kullanım Koşulları Türk hukukuna tabidir.</Paragraph>
          <Paragraph>
            Hüküm ve Koşullar ile bağlantılı bir anlaşmazlık olması durumunda, taraflar, birden fazla davalı söz konusu
            olmasına veya üçüncü kişilerce yapılan tazminat taleplerinin söz konusu olmasına bakılmaksızın, tarafların
            münhasır yargı yetkisini kabul ettiği Türkiye Cumhuriyeti yargı yetkisi altındaki mahkemelere başvurmadan
            önce, söz konusu anlaşmazlığı öncelikle sulh yoluyla çözmeye çalışacaklardır.
          </Paragraph>
        </Section>
        <MarginBox mt={60} />
        <SectionHeader title={'EK I'} underline />
        <SectionHeader title={'ALICI BİLGİLERİ - ERİŞİM PROSEDÜRÜ'} underline />
        <MarginBox mt={30} />
        <Image src={'terms-and-conditions/terms-and-conditions-FR.jpg'} alt={'Information diagram'} />
        <MarginBox mt={90} />
      </Flex>
    </Container>
  );
};
